// Dutchie Plus (isolated checkout) redirects the customer off-page via `window.location.href`
// on both success (after-submit.js) and error (use-cart-data-from-server.js) paths. Setting
// `location.href` doesn't unload the page synchronously -- other already-scheduled JS (like an
// in-flight `getCheckout` query erroring out around the same time as order creation succeeds)
// can still run and overwrite it with the error redirect before the browser navigates away. This
// flag lets the error path check whether the success redirect already fired and bail out instead
// of clobbering it.
let plusRedirectSucceeded = false;

export function markPlusRedirectSucceeded() {
  plusRedirectSucceeded = true;
}

export function hasPlusRedirectSucceeded() {
  return plusRedirectSucceeded;
}

// Test-only escape hatch for resetting the module-level flag between test cases.
export function __resetPlusRedirectStateForTests() {
  plusRedirectSucceeded = false;
}
